import type * as React from 'react';

import Snackbar from '@mui/material/Snackbar';

import ToastStore from '../stores/ToastStore';

const Toast: React.FC = () => {
    const {message, open} = ToastStore.useState(['message', 'open']);

    return (
        <Snackbar
            autoHideDuration={3000}
            open={open}
            onClose={() => ToastStore.close()}
            message={<span>{message}</span>}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        />
    );
};

export default Toast;
